import styled from 'styled-components'

const WrapperItem = styled.div`

`;

export { 
    WrapperItem
}